<template>
  <AquassistPage>
    <template v-slot:content>
      <form>
        <v-row
          v-if="isResetPassword"
          align="center"
          justify="center"
        >
          <span class="title white--text my-6">
            {{ $t('forms.btn.forgotPwd') }}
          </span>
        </v-row>
        <LoginForm
          :isResetPassword="isResetPassword"
          @validChanged="isFormValid = $event"
          @sendData="data = $event"
        />
        <v-row
          align="center"
          justify="center"
          class="mt-6"
        >
          <v-btn
            v-if="isResetPassword"
            text
            dark
            class="mr-5"
            @click="onClickToggle"
          >
            {{ $t('forms.btn.back') }}
          </v-btn>
          <v-btn
            :disabled="!isFormValid"
            width="247"
            type="submit"
            color="secondary"
            :data-cy="dataCy.loginForm.submit"
            @click.prevent="onClickSignIn"
          >
            {{ $t('forms.btn.submit') }}
          </v-btn>
        </v-row>
        <v-row
          align="center"
          justify="center"
          class="mt-6"
        >
          <v-btn
            v-if="!isResetPassword"
            text
            small
            color="#ffffff"
            @click="onClickToggle"
          >
            {{ $t('forms.btn.forgotPwd') }}
          </v-btn>
        </v-row>
        <router-link
          class="privacy-policy"
          to="/privacypolicy"
        >
          {{ $t('login.privacyPolicy') }}
        </router-link>
      </form>
    </template>
  </AquassistPage>
</template>

<script>
import LoginForm from '@/components/login/LoginForm.vue';
import AquassistPage from '@/components/login/AquassistPage.vue';
import { mapActions } from 'vuex';
import { loginForm } from '@/aq-data-cy.json';

export default {
    components: {
        LoginForm,
        AquassistPage,
    },
    data() {
        return {
            isResetPassword: false,
            isFormValid: false,
            data: null,
        };
    },
    computed: {
        dataCy() {
            return {
                loginForm,
            };
        },
    },
    methods: {
        ...mapActions({
            login: 'login',
        }),
        onClickSignIn() {
            if (this.isResetPassword) {
                const { email } = this.data;
                this.$rq.postRequestResetPassword({ email })
                    .then(response => {
                        this.$toasted.global.toast_success({
                            message: this.$t('msg.passwordReset', { user: response.data.name }),
                        });
                        this.resetPasswordToggle();
                    });
            } else {
                this.login(this.data);
            }
        },
        onClickToggle() {
            this.isResetPassword = !this.isResetPassword;
        },
    },
};
</script>
